// Module
var code = "<div mx-view=\"vm.mxExtraPanelManager.view\"></div>\r\n<md-button class=\"md-icon-button mx-extra-panel--close\" ng-click=\"vm.mxExtraPanelManager.close($event)\" title=\"{{'shell.common.close' | mxi18n}}\" aria-label=\"{{'shell.common.close' | mxi18n}}\">\r\n\t<md-icon>close</md-icon>\r\n</md-button>\r\n";
// Exports
export default code;